(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name commons.service:StyleGenerator
   *
   * @description
   *
   */
  angular
    .module('commons')
    .service('StyleGenerator', StyleGenerator);

  function StyleGenerator() {
    var self = this;

    self.addStyleTag = function (tagId,styleString) {
      if(tagId && styleString){
          var styleTag = angular.element(document).find('#' + tagId);
          if (styleTag.length == 0) {
            angular.element(document).find('head').append('<style type="text/css" id="' + tagId + '">' + styleString + '</style>');
          } else {
            styleTag.empty().append(styleString);
          }
      }
    };
    self.appendStyleTag = function (tagId,styleString) {
        if(tagId && styleString){
            var styleTag = angular.element(document).find('#' + tagId);
            if (styleTag.length == 0) {
              angular.element(document).find('head').append('<style type="text/css" id="' + tagId + '">' + styleString + '</style>');
            } else {
              styleTag.append(styleString);
            }
        }
      };
  }
}());
